(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.administration');
    module.directive('thirdPartyAppTable', [ThirdPartyAppTableDirectiveFn]);

    /* table directive */
    function ThirdPartyAppTableDirectiveFn() {

        var directive = {
            restrict: 'E',
            replace: true,
            templateUrl: '/app/settings/administration/modules/thirdpartyapps/templates/third-party-app-table.template.html',
            controller: 'ThirdPartyAppTableController',
            controllerAs: 'vm',
            bindToController: true
        };
        return directive;

    }

})();